export default __webpack_public_path__ + "static/media/sspds-pm.f3efa0e2.png";